﻿import { createSelector as createSelectorBase } from '../../utils/redux/createSelector.js';
import { getStore } from '../../utils/redux/store/getStore.js';

const createSelector = (path, defaultValue) =>
  createSelectorBase(path, defaultValue);

export const verifyDisabled = createSelector('app.verifyDisabled');

export const pageSelector = createSelector('app.page');
export const organizationSelector = createSelector('app.params.organization');
export const patientIdSelector = createSelector(['app.patient.id', 'app.params.patient']);
export const patientSerSelector = createSelector(['app.params.patientSer', 'app.patient.ser', 'app.params.ser']);

export const configSelector = createSelector('app.config', {});
export const meSelector = createSelector('app.me');
export const settingsSelector = createSelector('app.settings');
export const imageQueuePatientStatusSelector = createSelector('app.imageQueuePatientStatus');
export const settingsLoadedSelector = createSelector('app.settingsLoaded');

export const documentIdSelector = createSelector('app.params.documentId');
export const documentTypeSelector = createSelector('app.params.documentType');

export const settingsPageSelector = createSelector('app.params.page', 'main');

export const showOverlaySelector = createSelector('app.showOverlay');

/** @type {(function({}): SystemSettings)} */
export const systemSettingsSelector = createSelector('app.systemSettings');

export const paramSelector = (param, defaultValue = undefined) =>
  createSelector(`app.params.${param}`, defaultValue);

export const organizationIdSelector = (state = getStore().getState()) => {
  const me = meSelector(state);
  const { id } = ((me || { organizations: [] })
    .organizations.find(({ slug }) => organizationSelector(state) === slug) || {});

  if (id) return id;

  if (me) return me.organizations[0].id;
};

export const organizationSlugSelector = (state = getStore().getState()) => {
  const me = meSelector(state);
  const { slug } = ((me || { organizations: [] })
    .organizations.find(({ slug }) => organizationSelector(state) === slug) || {});

  if (slug) return slug;

  if (me) return me.organizations[0].slug;
};